import {
  ProjectRequestCountStoreAction,
  ProjectRequestCountStoreKind,
  ProjectRequestCountStoreType,
} from './projectRequestCountStore.types';

export const INITIAL_PROJECT_REQUEST_COUNT = {
  projectRequestCount: 0,
};

const projectRequestCountStore = (
  state: ProjectRequestCountStoreType,
  action: ProjectRequestCountStoreAction
): ProjectRequestCountStoreType => {
  switch (action.type) {
    case ProjectRequestCountStoreKind.INITIAL: {
      return { projectRequestCount: state.projectRequestCount + 1 };
    }
    default:
      throw new Error();
  }
};

export default projectRequestCountStore;
